import React from "react";
import { useNavigate } from "react-router";

function SignUpPage({type}) {
    const navigate = useNavigate();

    const handleDownloadFile = () => {
        let downloadURL = '';
        if(type==='dtx001'){
            downloadURL = process.env.REACT_APP_APPLY_DOC_URL_ALCOHOL;
        }else if(type==='dtx002'){
            downloadURL = process.env.REACT_APP_APPLY_DOC_URL_HEARRO;
        }else if(type==='dtx006'){
            downloadURL = process.env.REACT_APP_APPLY_DOC_URL_MOMTHERA;
        }
        if(downloadURL) window.open(downloadURL, "_blank");
    }
   
    return (
        <div className="signinLayout" style={{ width: '100vw', height: '100vh' }}>
			<div className="signinLayout__wrapper">
				<div className="signinLayout__wrapper__header" style={{margin: '0'}}>
                    <span className="signinLayout__wrapper__header__title">회원가입</span>
                </div>
                <div className="signinLayout__wrapper__body">
                    <div className="signinLayout__wrapper_body__text">
                        회원가입 양식서를 작성하여 digitalpharm@dgtpharm.com 로 메일 보내주세요.
                    </div>
                    <div className="signinLayout__wrapper__body__footer multiple">
						<button
							className="submitButton"
                            onClick={handleDownloadFile}
						>
							양식 다운로드
						</button>
                        <button
							className="cancelButton"
                            onClick={() => navigate(`/sign-in/${type}`)}
						>
							로그인 화면
						</button>
					</div>
                </div>
            </div>
        </div>
    )
}

export default SignUpPage;